import uamfStatusTypes from '../../consts/uamf/uamfStatusTypes';
import createAsyncRequestService from '../dam/asyncRequestService';
import uamfClientService from './uamfClientService';
import uamfWebSocketResponseService from './uamfWebSocketResponseService';

const uamfAsyncRequestService = createAsyncRequestService({
    prefix: 'UAMF',
    successStatus: uamfStatusTypes.SUCCEEDED,
    failedStatus: uamfStatusTypes.FAILED,
    pendingStatus: uamfStatusTypes.PENDING,
    checkRequestStatus: async (dusn, requestId) => {
        const requestData = await uamfClientService.getRequestStatus(dusn, requestId);

        const asyncMessage = {
            data: JSON.stringify({
                ...requestData,
                payload: {...requestData.payload, isHttpMessage: true},
            }),
        };

        uamfWebSocketResponseService.proceedMessage(asyncMessage);
    },
});

export default uamfAsyncRequestService;
